<script setup lang="ts">
import {Sharing} from "@/core/interfaces/Sharing";
import SharingStatus from "@/hospital/components/sharing/SharingStatus.vue";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{
    sharing: Sharing
}>();
</script>

<template>
  <div
    class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
  >
    <div class="flex justify-between items-start mb-3">
      <Icon name="mdi-hospital-building" class="mr-2" />
      <div class="flex-1">
        <h3 class="font-semibold text-lg text-gray-900">
          {{ sharing.tenant_name }}
        </h3>
      </div>
      <div class="text-right">
        <SharingStatus :status="sharing.status" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
      <div>
        <p v-if="sharing.authorized_at" class="text-gray-600">
          <span class="font-medium">Date d'autorisation:</span>
          {{ new Date(sharing.authorized_at).toLocaleDateString('fr-FR') }}
        </p>
        <p v-if="sharing.declined_at" class="text-gray-600">
          <span class="font-medium">Date de refus:</span>
          {{ new Date(sharing.declined_at).toLocaleDateString('fr-FR') }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
